module.exports = __webpack_public_path__ + "static/img/cqxc2.f5162e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/cqxc2.png
// module id = LFYl
// module chunks = 0